import { CAMPAIGN_STATUSES, NON_EDITABLE_CAMPAIGN_STATUSES } from "campaign/model"

export function isCampaignEditable(status: CAMPAIGN_STATUSES): boolean {
  return !NON_EDITABLE_CAMPAIGN_STATUSES.includes(status)
}
